import { AutogenModelBrokeragePlanningProfile, AutogenRowBrokeragePlanningProfile } from "./autogen/AutogenModelBrokeragePlanningProfile";

export class ModelBrokeragePlanningProfile extends AutogenModelBrokeragePlanningProfile<RowBrokeragePlanningProfile> {
    constructor() {
        super(RowBrokeragePlanningProfile);
    }
}

export class RowBrokeragePlanningProfile extends AutogenRowBrokeragePlanningProfile {
}